import React, {Component} from 'react';
import { Modal, Button, Alert } from 'react-bootstrap';

interface ModalDeleteWidgetProps {
  show: boolean,
    onHandleClose: Function,
    onDeleteWidget: Function,
    widgetInstance: any
}

interface ModalDeleteWidgetState {

}

class ModalDeleteWidget extends Component<ModalDeleteWidgetProps, ModalDeleteWidgetState> {
  constructor(props: any) {
    super(props);
    this.handleClose = this.handleClose.bind(this);
    this.handleDeleteWidget = this.handleDeleteWidget.bind(this);
  }

  handleClose() {
    const { onHandleClose} = this.props;
    onHandleClose();
  }

  handleDeleteWidget() {
    const { onDeleteWidget, widgetInstance } = this.props;
    onDeleteWidget(widgetInstance);
  }

  render() {
    const { show } = this.props;
    return (
      <Modal
        size="lg"
        show={show}
        centered
        onHide={this.handleClose}
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Widget</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>Are you sure you want to delete this widget?</p>
          <Alert variant="warning">Widget will be instantly deleted from dashboard and database.</Alert>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={this.handleClose}>Cancel</Button>
          <Button variant="danger" onClick={this.handleDeleteWidget}>Delete Widget</Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

export default ModalDeleteWidget;
